var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82.5,
    height: 67.09,
    viewBox: "0 0 82.5 67.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a,.d,.g{fill:#fff;}.b,.i,.j{fill:#64f884;}.c{clip-path:url(#a);}.d,.e,.f,.g{stroke:#2d2e2f;stroke-width:2.5px;}.d,.e,.f,.g,.i,.j{stroke-linecap:round;stroke-linejoin:round;}.e,.f{fill:none;}.e{stroke-dasharray:0.43 5.01;}.g{stroke-dasharray:0.6 5.26;}.h{clip-path:url(#c);}.i,.j{stroke:#222;}.i{stroke-width:1.105px;}.j{stroke-width:1.105px;}\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 82.5,
    height: 67.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 27.298,
    height: 27.292
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-303 -424.11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(344.25 457.655)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-41.25 -33.545)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.4,59.7V8.4L38.7,1.3V59.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M38.7,1.3l9.4,4.2V58.08H38.7"
  })), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y1: 4.9,
    x2: 24,
    transform: "translate(11.4 10.2)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y1: 4.3,
    x2: 24,
    transform: "translate(11.4 18.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y1: 3.3,
    x2: 24,
    transform: "translate(11.4 26.8)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y1: 2.4,
    x2: 24,
    transform: "translate(11.4 35.1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y1: 1.6,
    x2: 24,
    transform: "translate(11.4 43.2)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y1: 0.5,
    x2: 24,
    transform: "translate(11.4 51.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 80,
    transform: "translate(1.3 59.8)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 34.1,
    transform: "translate(39.7 65.8)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 11.1,
    transform: "translate(8.7 65.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M26.5,65.8h7.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M69.1,59.7H45V27.3L69.1,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M69.1,59.7h7V25.1l-7-3.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y1: 3.3,
    x2: 24.1,
    transform: "translate(45 34.8)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y1: 1.5,
    x2: 24.1,
    transform: "translate(45 47.3)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 33.4,
    transform: "translate(50.2 26.3)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 34.9,
    transform: "translate(56.2 24.8)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    y2: 36.1,
    transform: "translate(62.5 23.6)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.899 477.554)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(-13.649 -13.646)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M18.8,68.5c5.443.5,9.394,2.017,9.394,3.813s-5.857,4.006-13.1,4.006S2,74.523,2,72.34,5.979,69,11.394,68.5",
    transform: "translate(-1.447 -49.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M34.635,10.841c0,5.968-9.118,12.792-9.118,12.792S16.4,16.837,16.4,10.841,20.489,2,25.518,2,34.635,4.873,34.635,10.841Z",
    transform: "translate(-11.869 -1.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M43.852,23.926A3.426,3.426,0,1,1,40.426,20.5a3.426,3.426,0,0,1,3.426,3.426Z",
    transform: "translate(-26.777 -14.836)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsIcon);
export default __webpack_public_path__ + "static/media/locations-icon.4eaccda120586659be32250b04f644ec.svg";
export { ForwardRef as ReactComponent };